import React from "react";
import { CaptionProps, useNavigation } from "react-day-picker";
import { format } from "date-fns";
import pl from "date-fns/locale/pl";
import { Icon } from "@nju/icons";

export function CalendarCaption(props: CaptionProps) {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();
  return (
    <div className="flex justify-between items-center mb-3">
      <div
        className="flex items-center"
        onClick={() => {
          return previousMonth && goToMonth(previousMonth);
        }}
        role="button"
      >
        <Icon
          data-cy="show-previous-month"
          height={14}
          name="chevron-left"
          width={14}
        />
      </div>
      <span className="capitalize font-bold">
        {format(props.displayMonth, "LLLL yyyy", { locale: pl })}
      </span>
      <div
        className="flex items-center"
        onClick={() => {
          return nextMonth && goToMonth(nextMonth);
        }}
        role="button"
      >
        <Icon
          data-cy="show-next-month"
          height={14}
          name="chevron-right"
          width={14}
        />
      </div>
    </div>
  );
}
